export const sendWhatsAppInvoice = ({
  phone,
  invoiceNo,
  amount,
  dbId,
  branch
}) => {
  console.log("Preparing WhatsApp message with:", { phone, invoiceNo, amount, dbId, branch });
  if (!phone) {
    alert("Customer mobile number not available");
    return;
  }

  if (!dbId) {
    alert("Please save the invoice first to generate a shareable link.");
    return;
  }

  // Ensure India country code
  const formattedPhone = phone.startsWith("91") ? phone : `91${phone}`;

  // Construct the clean backend short link redirect URL
  const shortLink = `${process.env.REACT_APP_CRI_API}view-invoice/${dbId}?branch=${branch}`;

  const message = `Invoice No: ${invoiceNo}
Amount: ₹${amount}

View / Download Invoice:
${shortLink}

Thank you for your visit.`;

  const url = `https://wa.me/${formattedPhone}?text=${encodeURIComponent(message)}`;

  window.open(url, "_blank");
};

export const endWhatsAppPrescription = ({ phone, mrn, doctorName, pdfUrl }) => {
  const message = `Hello, your prescription is ready.\n\nMRN: ${mrn}\nDoctor: ${doctorName}\n\nDownload here: ${pdfUrl}`;

  const encodedMessage = encodeURIComponent(message);
  window.open(`https://wa.me/${phone}?text=${encodedMessage}`, "_blank");
};

export const sendWhatsAppPrescription = ({
  phone,
  mrn,
  doctorName,
  pdfUrl,
  branch
}) => {
  console.log("Preparing WhatsApp prescription message with:", { phone, mrn, doctorName, pdfUrl, branch });
  
  if (!phone) {
    alert("Patient mobile number not available");
    return;
  }

 // if (!dbId) {
 //   alert("Please save the prescription first to generate a shareable link.");
 //   return;
 // }

  // Ensure India country code
  const formattedPhone = phone.startsWith("91") ? phone : `91${phone}`;

  // Construct the clean backend short link redirect URL
  const shortLink =pdfUrl; // Assuming pdfUrl is already a valid link
  const message = `Hello, your prescription is ready.

MRN: ${mrn}
Doctor: ${doctorName}

View / Download Prescription:
${shortLink}

Thank you for your visit.`;

  const url = `https://wa.me/${formattedPhone}?text=${encodeURIComponent(message)}`;

  window.open(url, "_blank");
};